import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';

const Back = ({ path }) => (
  <div className="go-back">
    <Link to={path}>Back to All Posts</Link>
  </div>
);

Back.propTypes = {
  path: PropTypes.string.isRequired,
};

export default Back;
